module.exports = __webpack_public_path__ + "img/Newsletter.91a4f1be.png";